/* consolidates all child layers into one layer */
import ol = require("ol");
import $ = require("jquery");
import _ = require("underscore");
import Utils = require("../utils");
import Portal = require("portal-gis");

import BaseHelper = require("./base/group-helper");

class Helper extends BaseHelper {

    create() {
        _.defaults(this.options, { layerType: "group" });
        return super.create() || this.group();
    }

    private group() {
        let d = $.Deferred<ol.layer.Base>();
        let layer = this.layer;
        if (layer.Layers) {
            let layers = layer.Layers.Layers.filter(l => !l.disabled).map(childLayer => this.view.createLayer(childLayer));
            let req = Utils.when(layers);

            req.done(layers => {
                var groupOptions = <olx.layer.GroupOptions>{
                    id: layer.id,
                    title: layer.text,
                    layers: layers,
                    visible: "false" !== this.options["visible"]
                };

                var group = new ol.layer.Group(groupOptions);
                d.resolve(group);
            });

            req.fail(err => {
                console.error("unable to create group:", layer);
                d.reject(err);
            });

        }

        return d;
    }

}

class Handler {

    static about = `
Creates a [ol.layer.Group](http://openlayers.org/en/latest/apidoc/ol.layer.Group.html) to contain child layers.

Usage Example:

    <LAYER id="property-layer-group" text="Property" type="app/layer-factory/group">
    <LAYERS>
        <LAYER basemap="False" disabled="False" extent="-115.2589,36.15677,-115.1867,36.22891" id="parcels" maxlevel="24" minlevel="14" text="Parcels" type="app/layer-factory/arcgis-tile" url="https://usalvqa1.infor.com/arcgis/rest/services/IPS850/QASQL4850/MapServer">
        <OPTIONS>
            <Values id="layerType" value="rest" />
            <Values id="visible" value="true" />
        </OPTIONS>
        </LAYER>
    </LAYERS>
    </LAYER>

    `;

    static options = {
        "layerType": {
            "about": "This is a layer container",
            "default": "group",
            "domain": "group",
        },
        "visible": {
            "about": "Should this layer group be visible",
            "default": "true",
            "domain": "true|false",
        },
    }
    static create(args) {
        let options = Utils.asDictionary(args.layer.Options.Values);
        let helper = new Helper(args.layer, args.view, args.mediator, options);
        return helper.create();
    }

}

export = Handler; 